import { lazyNamed } from 'src/utils/lazyNamed';

export const AdMedium = {
  List: lazyNamed(() => import('./containers'), 'AdMediumTable'),
  Edit: lazyNamed(() => import('./containers/AdMediumItemEdit'), 'AdMediumItemForm'),
};
